module.exports = __webpack_public_path__ + "img/stop.4fadf764.png";